const displayText = value => typeof value === 'string' && value.trim() ? value : null

export function workFlowItemDisplay(item = {}) {
  if (item.node_type !== 'runtime_definition' && item.item_type !== 'runtime_definition') {
    return { name: item.name || '-', key: null }
  }
  // A published Flow's display projection is authoritative, including null fields.
  // Graph keys identify connections; they must never become Definition labels.
  const source = Object.prototype.hasOwnProperty.call(item, 'runtime_definition_display')
    ? item.runtime_definition_display
    : item.runtime_definition
  return {
    name: displayText(source?.name) || 'Rule 설정',
    key: displayText(source?.key),
  }
}
